import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppError } from '@models/appError';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        let msg: string;
        if (err.error instanceof Event) {
          msg = err.error?.message ?? 'Unknown error';
        } else {
          msg = err?.error?.message ?? 'Unknown error';
        }
        return throwError(
          new AppError(msg, err.status === 0 ? null : err.status, err.url)
        );
      })
    );
  }
}
